import type { FC } from 'react';
import styles from './PanelRight.module.css';
import type { PanelRightProps } from './PanelRight.types';

export const PanelRight: FC<PanelRightProps> = ({
  children,
  className = '',
}) => {
  return (
    <aside className={styles.panelRight + ' ' + className}>{children}</aside>
  );
};
